import React from 'react';
import { Title } from 'rizzui';
import cn from '../../utils/classNames';
import Breadcrumb from './breadcrumb';
import { useNavigate } from 'react-router-dom';

export type PageHeaderTypes = {
    title: string;
    subtitle?: string;
    breadcrumb?: { name: string; href?: string }[];
    titleClassName?: string;
    className?: string;
    isSticky?: boolean;
    headerFilters?: React.ReactNode;
    description?: string | null;
};

export default function PageHeader({ title, subtitle, breadcrumb, children, className, titleClassName, isSticky = true, headerFilters }: React.PropsWithChildren<PageHeaderTypes>) {

    const navigate = useNavigate();


    // RENDER
    
    return (
        <header className={cn('py-2 mb-4 @container top-[64px] bg-[#f0f0f5] z-[70] border-b border-[#e0]',  className, isSticky ? 'sticky ' : '')}>
            <div className="flex flex-col @lg:flex-row @lg:items-center @lg:justify-between">

                <div className='flex items-center gap-2 mb-2 @lg:mb-0'>

                    <div className="flex-1">

                        <Title
                            as="h2"
                            className={cn("mt-2 mb-2 text-[22px] lg:text-2xl 4xl:text-[26px]", titleClassName)}
                            >
                            {title}
                        </Title>

                        {subtitle && (
                            <p className="mb-2 mt-n2 text-gray-500 text-xs lg:text-base">
                                {subtitle}
                            </p>
                        )}

                        <Breadcrumb separator="" separatorVariant="circle" className={cn("flex-wrap", { "hidden": !breadcrumb })}>
                            {breadcrumb?.map((item) => (
                                <Breadcrumb.Item
                                key={item.name}
                                {...(item?.href && { href: item?.href })}
                                >
                                    {item.name}
                                </Breadcrumb.Item>
                            ))}
                        </Breadcrumb>

                    </div>

                </div>

                {headerFilters}

                {children}
            </div>
        </header>
    );
}